import React from 'react';
import type { BundledIntegration } from '../features/claudeagents/claudeAgentApi';

const chipStyle: React.CSSProperties = {
  cursor: 'pointer', font: 'inherit', background: 'rgba(0,176,211,0.1)', border: '1px solid rgba(0,176,211,0.25)',
  color: '#22d3ee', fontSize: 11, padding: '2px 8px', borderRadius: 5,
};

/** "Bundled integrations" group in an agent bundle preview - the API integrations
 *  turned on for the agent, next to its bundled skills and MCPs. */
const BundledIntegrationChips: React.FC<{ integrations?: BundledIntegration[]; onSelect: (integration: BundledIntegration) => void }> = ({
  integrations, onSelect,
}) => {
  if (!integrations?.length) return null;
  return (
    <div>
      <div className="mt-detail-field-label">Bundled integrations</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
        {integrations.map(i => (
          <button key={i.slug} type="button" style={chipStyle} onClick={() => onSelect(i)}
            title={i.needs_auth ? 'Needs an API key - whoever installs the agent adds their own' : undefined}>
            {i.name}{i.needs_auth ? ' 🔑' : ''}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BundledIntegrationChips;
